import { render, staticRenderFns } from "./QA_km.vue?vue&type=template&id=5bba7d0f&scoped=true&"
import script from "./QA_km.vue?vue&type=script&lang=js&"
export * from "./QA_km.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba7d0f",
  null
  
)

export default component.exports